import { httpClient } from '@totango-app-team/totango-utils/api';

export default httpClient;
